var React = require('react');

function CheckBlue (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"check-blue"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"check-blue","fillRule":"nonzero"},[React.createElement("circle",{"id":"Ellipse_1","fill":"#66A9F4","cx":"9.5","cy":"9.5","r":"9.5","key":0}),React.createElement("polygon",{"id":"ic_done_24px","stroke":"#FFFFFF","fill":"#FFFFFF","points":"8 12.045 5.375 9.42 4.5 10.295 8 13.795 15.5 6.295 14.625 5.42","key":1})]))]);
}

CheckBlue.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = CheckBlue;

CheckBlue.default = CheckBlue;
